<template>
  <div>
    <SubMenuHeader
      :title="$t('burgerMenu.language')"
      @onGoBack="onGoBack"
      @showVideo="$emit('showVideo')"
    />
    <div class="container mt-10 pt-6 pl-8">
      <div v-for="language in languages" :key="language.key" class="row p-3" @click="changeLanguage(language.key)">
        <div class="col">
          <input :id="language.id" type="radio" class="m-2 align-middle" name="language"
                 :checked="currentLanguage(language.key)">
          <label :for="language.id">{{ language.value }}</label><br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import { languageNames } from '../../../i18n/main';
import SubMenuHeader from '../../SubMenuHeader';
export default {
  'name': 'Languaje',
  'components': { SubMenuHeader },
  data() {
    return {
      'languages': languageNames
    }
  },
  'computed': {
    name() {
      return this.$t('login.language.change.button.label')
    },
    currentLocale() {
      return this.$i18n.locale()
    }
  },
  'methods': {
    ...mapActions([
      'changeLocale'
    ]),
    onGoBack() {
      this.$router.back();
    },
    currentLanguage(key) {
      if (key === this.currentLocale) {
        return true
      } else {
        return false
      }
    },
    'changeLanguage': function (language) {
      this.$i18n.set(language)
      this.changeLocale({ 'locale': language })
    }
  }
}
</script>

<style scoped>

</style>
